import {atom, DefaultValue, selector} from "recoil";

const storageKey = "freddosrl_guardian__token"

const tokenState = atom({
  key: 'token_state',
  default: localStorage.getItem('freddosrl_guardian__token') != null
    ? JSON.parse(localStorage.getItem('freddosrl_guardian__token'))
    : null,
})

const tokenSelector = selector({
  key: 'token_selector',
  get: ({get}) => {
    return get(tokenState)
  },
  set: ({set}, value) => {
    if (value instanceof DefaultValue) {
      set(tokenState, value)
      return;
    }
    set(tokenState, value)
    localStorage.setItem(storageKey, JSON.stringify(value))
  }
})

export {tokenSelector, tokenState}